var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvantage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 89,
    viewBox: "0 0 464 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5685 56.5813H17.5916L13.9551 67.0955H2.33421L22.1767 11.8369H35.0625L54.9049 67.0955H43.205L39.5685 56.5813ZM36.5645 47.7273L28.58 24.6436L20.5956 47.7273H36.5645ZM59.4759 45.0395C59.4759 40.6125 60.3454 36.6861 62.0846 33.2605C63.8765 29.8348 66.3008 27.1997 69.3576 25.3551C72.4143 23.5105 75.8136 22.5882 79.5555 22.5882C82.4014 22.5882 85.1156 23.2206 87.698 24.4855C90.2805 25.6977 92.3359 27.3314 93.8642 29.3868V8.5957H105.09V67.0955H93.8642V60.6131C92.494 62.7739 90.5703 64.513 88.0933 65.8306C85.6163 67.1482 82.744 67.8069 79.4764 67.8069C75.7873 67.8069 72.4143 66.8583 69.3576 64.961C66.3008 63.0637 63.8765 60.4022 62.0846 56.9766C60.3454 53.4982 59.4759 49.5192 59.4759 45.0395ZM93.9433 45.1976C93.9433 42.5097 93.4163 40.2172 92.3622 38.3199C91.3082 36.3699 89.8852 34.8942 88.0933 33.8929C86.3014 32.8388 84.3778 32.3118 82.3224 32.3118C80.267 32.3118 78.3697 32.8125 76.6305 33.8138C74.8913 34.8152 73.4684 36.2909 72.3616 38.2408C71.3076 40.1381 70.7805 42.4043 70.7805 45.0395C70.7805 47.6746 71.3076 49.9935 72.3616 51.9962C73.4684 53.9462 74.8913 55.4482 76.6305 56.5023C78.4224 57.5563 80.3197 58.0833 82.3224 58.0833C84.3778 58.0833 86.3014 57.5827 88.0933 56.5813C89.8852 55.5273 91.3082 54.0516 92.3622 52.1543C93.4163 50.2043 93.9433 47.8854 93.9433 45.1976ZM174.172 45.0395C174.172 40.6125 175.041 36.6861 176.78 33.2605C178.572 29.8348 180.97 27.1997 183.974 25.3551C187.031 23.5105 190.43 22.5882 194.172 22.5882C197.44 22.5882 200.286 23.247 202.71 24.5645C205.187 25.8821 207.163 27.5422 208.639 29.5449V23.2997H219.786V67.0955H208.639V60.6921C207.216 62.7475 205.24 64.4603 202.71 65.8306C200.233 67.1482 197.361 67.8069 194.093 67.8069C190.404 67.8069 187.031 66.8583 183.974 64.961C180.97 63.0637 178.572 60.4022 176.78 56.9766C175.041 53.4982 174.172 49.5192 174.172 45.0395ZM208.639 45.1976C208.639 42.5097 208.112 40.2172 207.058 38.3199C206.004 36.3699 204.581 34.8942 202.789 33.8929C200.997 32.8388 199.074 32.3118 197.018 32.3118C194.963 32.3118 193.066 32.8125 191.326 33.8138C189.587 34.8152 188.164 36.2909 187.057 38.2408C186.003 40.1381 185.476 42.4043 185.476 45.0395C185.476 47.6746 186.003 49.9935 187.057 51.9962C188.164 53.9462 189.587 55.4482 191.326 56.5023C193.118 57.5563 195.016 58.0833 197.018 58.0833C199.074 58.0833 200.997 57.5827 202.789 56.5813C204.581 55.5273 206.004 54.0516 207.058 52.1543C208.112 50.2043 208.639 47.8854 208.639 45.1976ZM254.865 22.6673C260.082 22.6673 264.298 24.3274 267.513 27.6476C270.728 30.9152 272.335 35.5003 272.335 41.403V67.0955H261.268V42.905C261.268 39.4267 260.398 36.7652 258.659 34.9206C256.92 33.0233 254.548 32.0747 251.544 32.0747C248.488 32.0747 246.063 33.0233 244.271 34.9206C242.532 36.7652 241.663 39.4267 241.663 42.905V67.0955H230.595V23.2997H241.663V28.7544C243.138 26.8571 245.009 25.3814 247.275 24.3274C249.594 23.2206 252.124 22.6673 254.865 22.6673ZM295.746 32.3909V53.5773C295.746 55.0529 296.088 56.1333 296.774 56.8185C297.511 57.4509 298.724 57.7671 300.41 57.7671H305.549V67.0955H298.592C289.263 67.0955 284.599 62.563 284.599 53.4982V32.3909H279.382V23.2997H284.599V12.4693H295.746V23.2997H305.549V32.3909H295.746ZM310.663 45.0395C310.663 40.6125 311.533 36.6861 313.272 33.2605C315.064 29.8348 317.462 27.1997 320.466 25.3551C323.522 23.5105 326.922 22.5882 330.664 22.5882C333.931 22.5882 336.777 23.247 339.201 24.5645C341.678 25.8821 343.655 27.5422 345.13 29.5449V23.2997H356.277V67.0955H345.13V60.6921C343.707 62.7475 341.731 64.4603 339.201 65.8306C336.724 67.1482 333.852 67.8069 330.584 67.8069C326.895 67.8069 323.522 66.8583 320.466 64.961C317.462 63.0637 315.064 60.4022 313.272 56.9766C311.533 53.4982 310.663 49.5192 310.663 45.0395ZM345.13 45.1976C345.13 42.5097 344.603 40.2172 343.549 38.3199C342.495 36.3699 341.072 34.8942 339.28 33.8929C337.488 32.8388 335.565 32.3118 333.509 32.3118C331.454 32.3118 329.557 32.8125 327.818 33.8138C326.078 34.8152 324.655 36.2909 323.549 38.2408C322.495 40.1381 321.968 42.4043 321.968 45.0395C321.968 47.6746 322.495 49.9935 323.549 51.9962C324.655 53.9462 326.078 55.4482 327.818 56.5023C329.609 57.5563 331.507 58.0833 333.509 58.0833C335.565 58.0833 337.488 57.5827 339.28 56.5813C341.072 55.5273 342.495 54.0516 343.549 52.1543C344.603 50.2043 345.13 47.8854 345.13 45.1976ZM384.241 22.5882C387.509 22.5882 390.381 23.247 392.858 24.5645C395.335 25.8294 397.285 27.4895 398.708 29.5449V23.2997H409.854V67.4117C409.854 71.4698 409.037 75.0799 407.404 78.242C405.77 81.4569 403.319 83.9866 400.052 85.8312C396.784 87.7285 392.831 88.6771 388.194 88.6771C381.975 88.6771 376.863 87.2278 372.857 84.3292C368.905 81.4305 366.665 77.4778 366.138 72.4711H377.126C377.706 74.4738 378.944 76.0549 380.842 77.2143C382.792 78.4265 385.137 79.0326 387.877 79.0326C391.092 79.0326 393.701 78.0576 395.704 76.1076C397.706 74.2103 398.708 71.3117 398.708 67.4117V60.6131C397.285 62.6684 395.308 64.3813 392.779 65.7515C390.302 67.1218 387.456 67.8069 384.241 67.8069C380.552 67.8069 377.179 66.8583 374.122 64.961C371.065 63.0637 368.641 60.4022 366.849 56.9766C365.11 53.4982 364.24 49.5192 364.24 45.0395C364.24 40.6125 365.11 36.6861 366.849 33.2605C368.641 29.8348 371.039 27.1997 374.043 25.3551C377.1 23.5105 380.499 22.5882 384.241 22.5882ZM398.708 45.1976C398.708 42.5097 398.181 40.2172 397.127 38.3199C396.073 36.3699 394.65 34.8942 392.858 33.8929C391.066 32.8388 389.142 32.3118 387.087 32.3118C385.031 32.3118 383.134 32.8125 381.395 33.8138C379.656 34.8152 378.233 36.2909 377.126 38.2408C376.072 40.1381 375.545 42.4043 375.545 45.0395C375.545 47.6746 376.072 49.9935 377.126 51.9962C378.233 53.9462 379.656 55.4482 381.395 56.5023C383.187 57.5563 385.084 58.0833 387.087 58.0833C389.142 58.0833 391.066 57.5827 392.858 56.5813C394.65 55.5273 396.073 54.0516 397.127 52.1543C398.181 50.2043 398.708 47.8854 398.708 45.1976ZM461.376 44.2489C461.376 45.83 461.271 47.253 461.06 48.5178H429.043C429.307 51.68 430.414 54.157 432.364 55.9489C434.314 57.7408 436.712 58.6367 439.558 58.6367C443.668 58.6367 446.593 56.8712 448.333 53.3401H460.27C459.005 57.5563 456.58 61.0347 452.997 63.7752C449.413 66.463 445.012 67.8069 439.795 67.8069C435.579 67.8069 431.784 66.8846 428.411 65.0401C425.091 63.1428 422.482 60.4813 420.585 57.0556C418.74 53.63 417.818 49.6773 417.818 45.1976C417.818 40.6652 418.74 36.6861 420.585 33.2605C422.429 29.8348 425.012 27.1997 428.332 25.3551C431.652 23.5105 435.473 22.5882 439.795 22.5882C443.958 22.5882 447.674 23.4841 450.941 25.276C454.262 27.0679 456.818 29.624 458.61 32.9442C460.454 36.2118 461.376 39.98 461.376 44.2489ZM449.914 41.0868C449.861 38.2408 448.833 35.9746 446.831 34.2882C444.828 32.549 442.377 31.6794 439.479 31.6794C436.738 31.6794 434.419 32.5226 432.522 34.2091C430.677 35.8429 429.544 38.1354 429.122 41.0868H449.914Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.36 37.1869H111.039L126.934 63.1746C128.096 65.0695 129.891 66.3689 131.951 66.8562L138.658 54.8369L128.36 37.1869Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25258_20576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 67,
    width: 14,
    height: 1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.854 67.0723H145.419L132.745 67.0182C133.115 67.0723 133.484 67.0723 133.854 67.0723Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25258_20576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.468 67.0182H132.793V67.0723H145.468V67.0182Z",
    fill: "url(#paint0_linear_25258_20576)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_25258_20576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 66,
    width: 2,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.896 67.0179H132.794C132.53 66.9638 132.266 66.9096 132.002 66.8555L131.896 67.0179Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_25258_20576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.794 66.8555H131.897V67.0179H132.794V66.8555Z",
    fill: "url(#paint1_linear_25258_20576)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_25258_20576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 54,
    width: 15,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.953 66.8549C132.217 66.909 132.481 66.9632 132.745 67.0173L145.419 67.0714L138.66 54.8356L131.953 66.8549Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_25258_20576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.419 54.8356H131.953V67.0714H145.419V54.8356Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_25258_20576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 54,
    width: 15,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.953 66.8549C132.217 66.909 132.481 66.9632 132.745 67.0173L145.419 67.0714L138.66 54.8356L131.953 66.8549Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_25258_20576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.419 54.8356H131.953V67.0714H145.419V54.8356Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_25258_20576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 54,
    width: 8,
    height: 14
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.468 67.0714L138.655 54.8356L145.468 67.0714Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_25258_20576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.467 54.8356H138.655V67.0714H145.467V54.8356Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_25258_20576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 8,
    width: 48,
    height: 47
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.604 8.81702C167.541 8.81702 165.376 10.2247 164.056 12.8776L144.781 44.7125L138.655 54.8369H155.818L185.179 8.81702H170.604Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_25258_20576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.179 8.81702H138.655V54.8369H185.179V8.81702Z",
    fill: "url(#paint2_linear_25258_20576)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25258_20576",
    x1: 132.773,
    y1: 67.031,
    x2: 145.444,
    y2: 67.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25258_20576",
    x1: 131.885,
    y1: 66.9284,
    x2: 132.778,
    y2: 66.9284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25258_20576",
    x1: 138.637,
    y1: 31.8073,
    x2: 185.151,
    y2: 31.8073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage);
export default __webpack_public_path__ + "static/media/Advantage.6ae80c43d41e6a103c33b59d02891843.svg";
export { ForwardRef as ReactComponent };